import { IconAlertCircle } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { CALENDAR_SECTION_ID } from "@/features/cart/helpers/configure-sections";
import type { CartItem } from "@/features/cart/types";
import { Link } from "@/i18n/navigation";

// Alert shown inside a cart diet card whose delivery dates are no longer
// available: the user has to pick a new date on the configuration view to
// complete the order.
export const CartDietDeliveryAlert = ({ item }: { item: CartItem }) => {
  const t = useTranslations();

  return (
    <div className="flex w-full flex-wrap items-center gap-3 rounded-xl bg-brand-red-50 p-4">
      <div className="flex items-center gap-3">
        <span className="flex shrink-0 items-center justify-center rounded-full bg-brand-red-300/8 p-2">
          <span className="flex items-center justify-center rounded-full bg-brand-red-300/12 p-1">
            <IconAlertCircle className="size-5" stroke={2} />
          </span>
        </span>
        <div className="min-w-0 flex-1">
          <p className="font-medium text-brand-green1-300 text-lg">
            {t("cart.deliveryUnavailable.title")}
          </p>
          <p className="text-brand-green1-300 text-sm">
            {t("cart.deliveryUnavailable.description")}
          </p>
        </div>
      </div>
      <Link
        className="ml-auto shrink-0 rounded-xl border border-brand-green2-300 bg-brand-white px-5 py-3 text-center font-medium text-base text-brand-green1-300 max-md:w-full"
        // Picking a new date is the only thing to do on the configuration view
        // from here, so the link lands straight on the calendar section instead
        // of the top of the page.
        href={{
          hash: CALENDAR_SECTION_ID,
          pathname: "/cart/[id]",
          params: { id: item.configurationItem.id || "" },
        }}
      >
        {t("cart.deliveryUnavailable.cta")}
      </Link>
    </div>
  );
};
